import { render, staticRenderFns } from "./PrestatairePropositionDrawer.vue?vue&type=template&id=464b4d02&"
import script from "./PrestatairePropositionDrawer.vue?vue&type=script&lang=js&"
export * from "./PrestatairePropositionDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports